// extracted by mini-css-extract-plugin
module.exports = {"singleName":"manageGym_singleName__1oAyD","singleNameText":"manageGym_singleNameText__27COl"};